import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import auth from './modules/auth';
import enums from './modules/enums';
import locations from './modules/locations';


Vue.use(Vuex);

const modules = {
  app,
  auth,
  enums,
  locations,
};

// Automatic registration of store modules from @modules
const requireModules = require.context(
  '@modules/',
  true,
  /^(((\.{1,2})|([a-zA-Z]+))\/)*([a-zA-Z]+\.)?(\b(store)\b)?$/,
);
requireModules.keys().forEach((path) => {
  const moduleName = requireModules(path).namespace || path.split('/')[1];
  const module = requireModules(path).default || requireModules(path);

  if (!module) {
    return;
  }

  modules[moduleName] = module;
});


export default new Vuex.Store({ modules });
